import { setTerm } from './helpers';

export const setWithDeposit = setTerm('zalog');
